import { useOutsideClick } from '@/hooks/useOutsideClick';
import { useCallback, useEffect, useState } from 'react';

export const useSlideComponent = (mainRef: React.RefObject<HTMLDivElement | null>, preventDeselectRefs: React.RefObject<HTMLDivElement | null>[], preview?: boolean) => {
    const [isSelected, setIsSelected] = useState(false);

    useOutsideClick(
        mainRef,
        (event) => {
            if (preview) return;
            if (!preventDeselectRefs) return;

            // Check if click target is contained in any of the prevent refs
            const isInsidePreventRef = preventDeselectRefs.some((preventRef) => preventRef.current && preventRef.current.contains(event.target as Node));

            // prevent deselect when closing mui menu item
            const isInModal = (event.target as Element)?.closest('.MuiPopover-root');

            // If click is not inside any prevent ref element, deselect
            if (!isInsidePreventRef && !isInModal) {
                setIsSelected(false);
            }
        },
        !preview,
    );

    const onSelectComponent = useCallback(() => {
        if (preview) return;
        if (!mainRef.current) return;

        const clickHandler = () => {
            setIsSelected(true);
        };

        mainRef.current.addEventListener('mousedown', clickHandler);

        return () => {
            if (mainRef.current) {
                mainRef.current.removeEventListener('mousedown', clickHandler);
            }
        };
    }, [mainRef, preview]);

    useEffect(() => {
        onSelectComponent();
    }, [onSelectComponent]);

    return { isSelected };
};
